export default "__VITE_ASSET__Brrx5qJ8__"